import * as Yup from 'yup';
import {isPossiblePhoneNumber} from 'react-phone-number-input';

export const registerFormValidationSchema = (
    withoutBusinessCountry?: boolean,
) => {
    const base = Yup.object().shape({
        gender: Yup.string().required('Required'),
        firstName: Yup.string().required('Required'),
        lastName: Yup.string().required('Required'),
        email: Yup.string()
            .email('Email address must be valid')
            .required('Required'),
        phone: Yup.string()
            .required('Required')
            .test('valid_phonenumber', 'Invalid phone number', value =>
                isPossiblePhoneNumber(value),
            ),
        plainPassword: Yup.string()
            .required('Required')
            .test(
                'regex',
                'Password must be min 8 characters, and have 1 Uppercase, 1 Number and 1 Lowercase',
                val => {
                    const regExp = new RegExp(
                        '^(?=.*\\d)(?=.*[a-z, !@#$%^&*])(?=.*[A-Z]).{8,}$',
                    );
                    return regExp.test(val);
                },
            ),
        acceptTerms: Yup.bool().oneOf([true], 'Required'),
    });

    return withoutBusinessCountry
        ? base
        : base.concat(
              Yup.object().shape({
                  businessCountry: Yup.string().nullable().required('Required'),
              }),
          );
};

export const resetPasswordValidationSchema = Yup.object().shape({
    password: Yup.string()
        .required('Required')
        .test(
            'regex',
            'Password must be min 8 characters, and have 1 Uppercase, 1 Number and 1 Lowercase',
            val => {
                const regExp = new RegExp(
                    '^(?=.*\\d)(?=.*[a-z, !@#$%^&*])(?=.*[A-Z]).{8,}$',
                );
                return regExp.test(val);
            },
        ),
});
